import posthog from 'posthog-js';

// PostHog project: SFN Ai
// Public API key — safe to include in client-side code
const POSTHOG_KEY = 'phc_sa5NWQDNz96og25gLJZZYfb57sxjCvcnkLdxYEjjMSri';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

export function initPostHog() {
  if (typeof window === 'undefined') return;
  if (process.env.NODE_ENV === 'development') return;
  // Playwright (and any other automation-driven browser) sets navigator.webdriver
  // — a real user's browser never does. Skip real PostHog entirely under
  // automation instead of relying on every E2E spec to independently remember
  // to block eu.i.posthog.com: unblocked, autocapture/session-recording/identify
  // calls contend with app navigations (e.g. window.location.href hard
  // redirects) on a resource-constrained CI runner and have caused flaky
  // hangs — see 20_content_rewards_community_join.spec.ts.
  if (typeof navigator !== 'undefined' && navigator.webdriver) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      maskInputFn: (text, element) => {
        if ((element as HTMLInputElement)?.type === 'password') return '*'.repeat(text.length);
        if ((element as HTMLElement)?.dataset?.sensitive === 'true') return '*'.repeat(text.length);
        return text;
      },
      // Record sessions for all users, including anonymous (pre-login) sessions.
      // person_profiles: 'identified_only' would otherwise suppress anonymous recordings.
      recordCrossOriginIframes: false,
    },
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') ph.debug();
    },
  });
}

export { posthog };
